export const ExternalTemplate = (data) => {
    return `<div class="preview--block external">${data.embed}</div>`;
};

export default ExternalTemplate;
